import React from "react";
import { Typography, Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

import Logo from "../../../../getKampus.png";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    //backgroundColor: "#abe",
    // maxWidth: theme.spacing(40),
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "row-reverse",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  messageText: {
    // backgroundColor: "#abe",
    maxWidth: theme.spacing(40),
    marginRight: theme.spacing(1),
  },
  messageBubble: {
    backgroundColor: "#abe",
    borderRadius: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: 4,
    paddingBottom: 4,
  },
}));

export default function ChatItemSend(props) {
  const {text, name, photoURL} = props.message;
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Avatar src={photoURL ||Logo} />
      <div className={classes.messageText}>
        <Typography variant="body1" className={classes.messageBubble}>
          {text}
        </Typography>
        <Typography variant="body2" align="right" style={{ color: "grey" }}>
          {name}
        </Typography>
      </div>
    </div>
  );
}
